import { render, staticRenderFns } from "./SolicitudesView.vue?vue&type=template&id=854c6738&scoped=true"
import script from "./SolicitudesView.vue?vue&type=script&lang=js"
export * from "./SolicitudesView.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesView.vue?vue&type=style&index=0&id=854c6738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854c6738",
  null
  
)

export default component.exports